import { Info } from "lucide-react";
import { PlatformConnection } from "../models/Platform";
import { Portal as TooltipPortal } from "@radix-ui/react-tooltip";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

/** Passive platform limits belong in one place; reconnect actions stay in the notice. */
export function AnalyticsCoverageInfo({ connections }: {
  connections: Pick<PlatformConnection, "platform" | "entityType" | "status">[];
}) {
  const active = connections.filter(connection => connection.status !== "revoked");
  const notes = [
    ...(active.some(connection => connection.platform === "linkedin" && connection.entityType !== "organization")
      ? [{ title: "LinkedIn personal profiles", text: "LinkedIn restricts importing posts from personal profiles. Only posts published through Wavegen appear here for those profiles." }] : []),
    ...(active.some(connection => connection.platform === "instagram")
      ? [{ title: "Instagram Stories", text: "Instagram Stories are excluded from Top posts. Feed posts and Reels are included." }] : []),
    ...(active.some(connection => connection.platform === "facebook")
      ? [{ title: "Facebook Stories", text: "Facebook Stories aren’t currently included in Wavegen analytics. Page posts and Reels are included." }] : []),
    ...(active.some(connection => connection.platform === "youtube")
      ? [{ title: "YouTube videos", text: "Only public YouTube videos are imported. Private and unlisted videos are excluded." }] : []),
  ];
  if (!notes.length) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" className="inline-flex min-h-9 items-center gap-1.5 rounded-md px-2 text-xs font-medium text-muted-foreground hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
          <Info className="h-3.5 w-3.5" aria-hidden />
          Platform limitations
        </button>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent side="bottom" align="start" className="w-96 max-w-[calc(100vw-2rem)] max-h-[70vh] overflow-y-auto p-4">
          <h2 className="text-sm font-semibold">Platform limitations</h2>
          <dl className="mt-2 divide-y divide-border">
            {notes.map(note => (
              <div key={note.title} className="py-3 last:pb-0">
                <dt className="text-sm font-medium">{note.title}</dt>
                <dd className="mt-1 text-sm leading-5 text-muted-foreground">{note.text}</dd>
              </div>
            ))}
          </dl>
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
}
